export const SCHEDULED_APPOINTMENT_REQUIRED_MESSAGE =
  'Recording and note generation require a scheduled appointment.';
